<div class="agent-dir">
  <h4 class="agent-dir__title">{{ 'chatAi.agents.directory.title' | translate }}</h4>
  <div class="agent-dir__list">
    <app-agent-card *ngFor="let agent of agents; trackBy: trackByCode"
                    [agent]="agent"
                    (talk)="startChat.emit($event)">
    </app-agent-card>
  </div>
</div>
